import { Injectable } from '@angular/core';
import type { PaginationRequiredQueryInterface } from '@zaoblako/shared/common/dtos/pagination-required-query.dto';
import type { DealSynchronizeHistoryInterface } from '@zaoblako/shared/modules/business/dto/deal/deal-synchronize-history-find.dto';
import type { DealsGroupFindInterface } from '@zaoblako/shared/modules/business/dto/deals-group/deals-group-find.dto';
import type { DealsGroupHistoryListInterface } from '@zaoblako/shared/modules/business/dto/deals-group/deals.group.history.list.dto';
import type { DealsGroupsListQueryInterface } from '@zaoblako/shared/modules/business/dto/deals-group/deals.groups.list.query.dto';
import type { UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DealGroupsService extends BaseService {
  protected baseUrl = '/finance/business/deals-groups';

  public flat(queryParams?: DealsGroupsListQueryInterface): Observable<DealsGroupFindInterface[]> {
    return this.http.get<DealsGroupFindInterface[]>(`${this.baseUrl}/flat`, { params: this.objectToHttpParams(queryParams) });
  }

  public synchronizeAll(): Observable<DealSynchronizeHistoryInterface[]> {
    return this.http.get<DealSynchronizeHistoryInterface[]>(`${this.baseUrl}/synchronize`);
  }

  public getMembers(dealGroupId: number): Observable<UserFindInterface[]> {
    return this.http.get<UserFindInterface[]>(`${this.baseUrl}/${dealGroupId}/participants`);
  }

  public getHistory(dealGroupId: number, params: PaginationRequiredQueryInterface): Observable<DealsGroupHistoryListInterface> {
    return this.http.get<DealsGroupHistoryListInterface>(`${this.baseUrl}/${dealGroupId}/history`, {
      params: this.objectToHttpParams(params)
    });
  }
}
